import { CheckCircle2, Zap, Target, Users, Globe2, Trophy } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";
import { useTilt } from "../../hooks/useInteractions";
import Reveal from "../shared/Reveal";

const values_en = [
  { icon: Globe2, title: "One-stop solution", desc: "Strategy, tech, marketing and creative — under one roof." },
  { icon: Target, title: "Regional expertise", desc: "Deep understanding of Gulf markets, culture and regulation." },
  { icon: Zap, title: "Fast execution", desc: "Cross-functional pods ship in weeks, not quarters." },
  { icon: Trophy, title: "Measurable ROI", desc: "Every engagement is tied to business KPIs, not vanity metrics." },
  { icon: Users, title: "Custom technology", desc: "We engineer, we don't re-sell. Full ownership of outcomes." },
  { icon: CheckCircle2, title: "Long-term partner", desc: "From zero-to-one and beyond — we scale with you." },
];
const values_ar = [
  { icon: Globe2, title: "حل شامل", desc: "الاستراتيجية والتقنية والتسويق والإبداع تحت سقف واحد." },
  { icon: Target, title: "خبرة إقليمية", desc: "فهم عميق للسوق الخليجي والثقافة والتنظيم." },
  { icon: Zap, title: "تنفيذ سريع", desc: "فرق متعددة التخصصات تسلّم خلال أسابيع." },
  { icon: Trophy, title: "عائد قابل للقياس", desc: "كل عمل مرتبط بمؤشرات أعمال حقيقية." },
  { icon: Users, title: "تقنية مخصصة", desc: "نصمم ونهندس ولا نعيد البيع." },
  { icon: CheckCircle2, title: "شريك طويل الأمد", desc: "من الصفر إلى التوسع ندعمكم." },
];

const TiltCard = ({ icon: Icon, title, desc, idx }) => {
  const ref = useTilt(6);
  return (
    <div
      ref={ref}
      data-testid={`value-card-${idx}`}
      className="tilt-card group relative glass rounded-2xl p-7 hover:border-cyan-400/40 transition-all"
    >
      <div className="relative z-10">
        <div className="w-10 h-10 rounded-lg bg-cyan-400/10 border border-cyan-400/30 flex items-center justify-center mb-5 group-hover:bg-cyan-400/20 transition">
          <Icon className="w-5 h-5 text-cyan-300" />
        </div>
        <h3 className="text-lg font-semibold text-strong mb-2">{title}</h3>
        <p className="text-mid text-sm leading-relaxed">{desc}</p>
      </div>
      {/* Corner mark */}
      <div className="absolute top-4 right-4 text-[10px] mono-label text-faint opacity-0 group-hover:opacity-100 transition">0{idx + 1}</div>
    </div>
  );
};

export const WhyUs = () => {
  const { t, lang } = useLang();
  const values = lang === "en" ? values_en : values_ar;

  return (
    <section className="relative py-20 md:py-32 overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8">
        <Reveal variant="fade-up" className="max-w-2xl mb-14">
          <div className="text-xs mono-label text-cyan-400 mb-3">{t.why.eyebrow}</div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight text-strong">
            {t.why.title}
          </h2>
          <p className="mt-4 text-base text-mid leading-relaxed">{t.why.subtitle}</p>
        </Reveal>

        <Reveal variant="fade-up" stagger={90} className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {values.map((v, i) => (
            <TiltCard key={i} icon={v.icon} title={v.title} desc={v.desc} idx={i} />
          ))}
        </Reveal>
      </div>
    </section>
  );
};

export default WhyUs;
